import DayCellRenderer from "./DayCellRenderer";

export default class UserDayCellRenderer extends DayCellRenderer {
    buildContent(cell) {
        cell.getCellEl().innerHTML = this.parseTime(cell.getValue().actuals);
    }

    addTooltip(cell) {
        cell.getRow().getTable().getTooltipController().addDayTooltip(cell.getCellEl(),
            cell.getRow().getHeaderCell().getValue().id,
            cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date,
            cell.getRow().getUserLeaveInfo(cell.getColIdx()),
            {showOvertimeWhenZero: false, time: cell.getRow().getUserOvertimeInfo(cell.getColIdx()), showTime: true},
            cell.getValue());
    }

    getCellClassName(cell) {
        var className = ["userDayCell"];

        if (cell.getRow().isTodayCell(cell))
            className.push("Today");
        else if (cell.getRow().isHolidayCell(cell))
            className.push("Holiday");

        if (cell.getValue().locked)
            className.push("Locked");

        if (cell.getRow().isExpanded())
            className.push("Expanded");

        if (this.isSelected(cell))
            className.push("Selected");
        else if (this.isHovered(cell))
            className.push("Hover");

        if (cell.getValue().approveInfo && (cell.getValue().approveInfo.approved || cell.getValue().approveInfo.autoApproved ))
            className.push("Approved");
        return className.join(" ");
    }
}



// WEBPACK FOOTER //
// ./web/js/locktable/renderers/UserDayCellRenderer.js